import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Carts } from '../../../core/services/carts.service';
import { Router } from '@angular/router';
import { Auth } from '../../../core/services/auth.service';

@Component({
  selector: 'app-shop-cart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shop-cart.html',
  styleUrl: './shop-cart.css',
})
export class ShopCart implements OnInit {
  @Output() requestLogin = new EventEmitter<void>();

  constructor(
    public cart: Carts,
    private router: Router,
    private auth: Auth
  ) {}

  ngOnInit() {
    this.cart.refreshCart();
  }

  close() {
    this.cart.isOpen.set(false);
  }

  checkout() {
    if (!this.auth.isLoggedIn()) {
      this.cart.isOpen.set(false);
      this.cart.requireLoginForCheckout();
      this.requestLogin.emit();
      return;
    }
    this.cart.toggleCart();
    this.router.navigate(['/checkout']);
  }
}
